import React, { useContext, useState, useRef, useCallback, useEffect } from 'react'
import { UserContext } from 'v2/context/user'
import { NAMED_HELP_WIZARD_STEPS } from 'v2/constants/wizards'

import XUnauthPage from 'v2/containers/xUnauthPage'
import XAuthPage from 'v2/containers/xAuthPage'
import StepWizard from 'react-step-wizard'

import HelpFAQ from 'v2/containers/help/helpFAQ'
import HelpSelector from 'v2/containers/help/helpSelector'
import HelpContactUs from 'v2/containers/help/helpContactUs'
import HelpEmail from 'v2/containers/help/helpEmail'

import styles from './style.module.scss'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import ConditionalRender from '../../../utils/conditionalRender'
import { OrganizationContext } from '../../context/organization'

interface Props {}

const HELP_SECTIONS = {
    '': 'HELP_SELECTOR',
    faq: 'HELP_FAQ',
    email: 'HELP_EMAIL',
    contact: 'HELP_CONTACT_US',
}

const HelpWizard: React.FC<Props> = (props: Props) => {
    const router = useRouter()
    const [step, setStep] = useState<number>(
        NAMED_HELP_WIZARD_STEPS[HELP_SECTIONS[router.query.subsection?.toString()]]
    )
    const stepWizardRef = useRef(null)
    const userContext = useContext(UserContext)

    useEffect(() => {
        setStep(NAMED_HELP_WIZARD_STEPS[HELP_SECTIONS[router.query.subsection?.toString()]])
    }, [router])

    const navigateToStep = useCallback(() => {
        router.push(`/v2/${router.query['program-name']}/help`)
        stepWizardRef.current.goToStep(NAMED_HELP_WIZARD_STEPS.HELP_SELECTOR)
    }, [stepWizardRef])

    const PageComponent = userContext.authenticatedUser ? XAuthPage : XUnauthPage

    return (
        <PageComponent
            sidebar={!!userContext.authenticatedUser}
            fullHeight={!userContext.authenticatedUser}
            isLanguageSwitcher={true}
        >
            <div className={clsx(styles.wrapper, styles.wrapper__fullHeight)}>
                <StepWizard
                    //@ts-ignore
                    ref={stepWizardRef}
                    className={styles.stepWizard}
                    transitions={{
                        enterRight: '',
                        enterLeft: '',
                        exitRight: '',
                        exitLeft: '',
                    }}
                    isLazyMount={true}
                    initialStep={step}
                    onStepChange={(stepInfo: { previousStep: number; activeStep: number }) => {
                        window.scrollTo(0, 0)
                        setStep(stepInfo.activeStep)
                    }}
                >
                    <HelpSelector />
                    <HelpFAQ
                        onBack={() => {
                            navigateToStep()
                        }}
                    />
                    <HelpEmail
                        onBack={() => {
                            navigateToStep()
                        }}
                    />
                    <HelpContactUs
                        onBack={() => {
                            navigateToStep()
                        }}
                    />
                    <HelpEmail
                        onBack={() => {
                            navigateToStep()
                        }}
                    />
                </StepWizard>
            </div>
        </PageComponent>
    )
}

export default HelpWizard
